import script from "./AboutP.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutP.vue?vue&type=script&setup=true&lang=js"

import "./AboutP.vue?vue&type=style&index=0&id=3f88db47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f88db47"]])

export default __exports__